import { api } from "@/lib/api";

export async function startCheckout(lookupKey, sheetId) {
  const { data } = await api.post("/payments/checkout", {
    lookup_key: lookupKey,
    sheet_id: sheetId || null,
    origin_url: window.location.origin,
  });
  window.location.href = data.checkout_url;
}

export function triggerDownload(blob, name) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = name; a.click();
  URL.revokeObjectURL(url);
}

export function isPremium(user) {
  const plan = user?.premium?.plan;
  return plan === "lifetime" || plan === "monthly";
}

export function hasSheet(user, sheetId) {
  return isPremium(user) || (user?.premium?.unlocked_sheets || []).includes(sheetId);
}

export const formatPrice = (amount, currency = "eur") =>
  new Intl.NumberFormat("pt-PT", { style: "currency", currency: currency.toUpperCase() }).format(amount);
